import React, {
  Fragment,
  useEffect,
  useState,
  useContext,
  useCallback,
} from "react";
import Administrative from "./Administrative";
import axios from "axios";
import { awsUrl2 } from "../../../config";
import { Auth } from "aws-amplify";
import PricingTableSummary from "./PricingTableSummary";
import UnbundledRate from "./UnbundledRate";
import PDFMerger from "pdf-merger-js/browser";
import SmallLoader from "../../../newcomponent/common/smallLoader";
import { LibertateContext } from "../../../context/Context";
import styles from "./FormViewProposal.module.scss";
import moment from "moment";
import DownloadEAcord from "../sections-quote/DownloadEAcord";
import { proposalComments } from "../../../utils/proposalComments";
import { isExistingBusiness } from "../../../utils/fieldAccess";
import { updateApprovalStatus } from "../sections-quote/pricing-tool/utils/utils";
import toast, { Toaster } from "react-hot-toast";
import { coastPeoCharges } from "../../../utils/peoChargesQns";
import { shouldDisableActionButton } from "../../../utils/buttonDisableFun";
const FormViewProposal = ({ updatePopUpData }) => {
  let libertateContext = useContext(LibertateContext);
  const [administrativeData, setAdministrativeData] = useState({});
  const [coastPeoChargesData, setCoastPeoChargesData] = useState({});
  const [administrativeDataLoader, setAdministrativeDataLoader] =
    useState(true);
  const [pricingTablesummaryDataLoader, setPricingTablesummaryDataLoader] =
    useState(true);
  const [unbundledRateDataLoader, setUnbundledRateDataLoader] = useState(true);
  const [downloadDocumnetloader, setDownloadDocumnetloader] = useState(false);
  const [downloadCAFLoader, setdownloadCAFLoader] = useState(false);
  const [saveResponseloader, setSaveResponseLoader] = useState(false);
  const [editedCompanyNameViewProposal, setEditedCompanyNameViewProposal] =
    useState("");
  const [editedquoteGenratedDate, seteditedquoteGenratedDate] = useState("");
  const [changePeoCharges, setChangePeoCharges] = useState(
    libertateContext?.pricingToolData?.selectedPeo === "coast",
  );
  const [signaturePersonInfo, setSignaturePersonInfo] = useState({
    Id: "",
    names: "",
    email: "",
    phone_number: "",
    role: "",
  });

  const [signatureNamesDB, setSignatureNamesDB] = useState([]);

  const [companyNameError, setCompanyNameError] = useState(false);
  const [commentError, setCommentError] = useState(false);
  const [displayTable, setDisplayTable] = useState(false);
  // States for Comments, Selected dropdown and Comments
  const [comments, setComments] = useState(proposalComments);
  const [selectedTitle, setSelectedTitle] = useState(
    libertateContext?.proposalCommentState?.selectedTitle ||
      proposalComments[0]?.Title,
  );
  const [editedText, setEditedText] = useState(
    libertateContext?.proposalCommentState?.editedText ||
      proposalComments[0]?.Text,
  );
  let miscSalesforceDatacheck = JSON.parse(
    sessionStorage.getItem("miscSalesforceData"),
  )?.submissionData?.proposalNumber;

  const [proposalEdit, setProposalEditNumber] = useState(
    libertateContext?.pricingToolData?.proposalNumber || "",
  );

  useEffect(() => {
    if (libertateContext?.pricingToolData?.proposalNumber) {
      setProposalEditNumber(libertateContext.pricingToolData.proposalNumber);
    }
  }, [libertateContext?.pricingToolData?.proposalNumber]);
  useEffect(() => {
    if (editedCompanyNameViewProposal?.length > 48) {
      setCompanyNameError(true);
    } else {
      setCompanyNameError(false);
    }
  }, [editedCompanyNameViewProposal]);

  let salesforceData;
  {
    try {
      salesforceData =
        JSON.parse(sessionStorage.getItem("salesforceData")) || null;
    } catch (error) {}
  }
  useEffect(() => {
    const fetchsalesnames = async () => {
      const response = await axios.post(awsUrl2 + "/api/salesPersonNamesFetch");

      setSignatureNamesDB(response?.data);

      console.log(signatureNamesDB, "signp");
    };
    fetchsalesnames();
  }, []);

  let currProspect = sessionStorage.getItem("currProspect");
  let companyProfileData;
  let quoteData = sessionStorage.getItem("quoteData");
  quoteData = JSON.parse(quoteData);
  let companyName = "",
    quoteGeneratedDate = "",
    quoteEffectiveDate = "",
    proposalId =
      generateEndorsementNumber() ||
      libertateContext?.pricingToolData?.proposalNumber;
  try {
    currProspect = JSON.parse(currProspect);
    companyName = currProspect?.companyProfile?.companyName?.value;
    quoteGeneratedDate = quoteData?.["date"] || "";
    quoteEffectiveDate = currProspect?.companyProfile?.effectiveDate.value;
    companyProfileData = currProspect?.companyProfile;
  } catch (error) {
    console.log("++error", error);
  }

  const coastChanges = (checked) => {
    setChangePeoCharges(checked);
    libertateContext.updatePricingToolData(
      "selectedPeo",
      checked ? "coast" : "ies",
    );
  };

  useEffect(() => {
    seteditedquoteGenratedDate(quoteGeneratedDate);
  }, [quoteGeneratedDate]);

  // UseEffect to reset to local state from context api states
  useEffect(() => {
    if (libertateContext?.proposalCommentState) {
      // When context changes, update our selected title and text
      if (
        libertateContext.proposalCommentState.selectedTitle !== selectedTitle
      ) {
        setSelectedTitle(libertateContext.proposalCommentState.selectedTitle);
        setEditedText(libertateContext.proposalCommentState.editedText);
      }
    }
  }, [libertateContext?.proposalCommentState]);

  useEffect(() => {
    if (libertateContext && libertateContext.pricingToolData) {
      try {
        const peoCharges = libertateContext?.pricingToolData?.peoCharges;
        const coastPeoChargesEdit =
          libertateContext?.pricingToolData?.coastPeoCharges;
        let editedCompanyNamePresent =
          libertateContext?.pricingToolData?.editedCompanyNameViewProposal;
        let signaturePersonInfoPresent =
          libertateContext?.pricingToolData?.signaturePersonInfo;
        console.log(signaturePersonInfoPresent, "signaturePersonInfoPresent");

        const savedPeo = libertateContext?.pricingToolData?.selectedPeo;
        if (savedPeo) {
          setChangePeoCharges(savedPeo === "coast");
        }

        setAdministrativeData(peoCharges);
        if (
          !coastPeoChargesEdit ||
          Object.keys(coastPeoChargesEdit).length === 0
        ) {
          setCoastPeoChargesData(coastPeoCharges);
        } else {
          setCoastPeoChargesData(coastPeoChargesEdit);
        }
        setPricingTablesummaryDataLoader(false);
        setUnbundledRateDataLoader(false);
        setAdministrativeDataLoader(false);
        setEditedCompanyNameViewProposal(editedCompanyNamePresent);
        setSignaturePersonInfo(signaturePersonInfoPresent);
      } catch (error) {
        console.error("An error occurred while processing data:", error);
      }
    }
  }, [libertateContext.pricingToolData]);

  useEffect(() => {
    const fetchAdditionalDetails = async () => {
      let isLoggedIn = await Auth.currentAuthenticatedUser();
      let userGroups =
        isLoggedIn.signInUserSession.accessToken.payload["cognito:groups"];

      let isOpsLogin = [process.env.REACT_APP_OPS_GROUP];
      let displayTableCheck = !userGroups.some((e) => isOpsLogin.includes(e));
      setDisplayTable(displayTableCheck);
    };
    fetchAdditionalDetails();
  });
  // Handler for comment dropdown change
  const handleTitleChange = (e) => {
    const title = e.target.value;
    setSelectedTitle(title);

    // if(title === libertateContext?.proposalCommentState?.selectedTitle) {
    //   setEditedText(libertateContext?.proposalCommentState?.editedText);
    //   return;
    // }

    // First try to get the text from context (which has saved versions)
    const contextComment =
      libertateContext?.proposalCommentState?.comments?.find(
        (comment) => comment.Title === title,
      );

    // If found in context, use that, otherwise use local comments
    const text =
      contextComment?.Text ||
      comments.find((comment) => comment.Title === title)?.Text ||
      "";

    setEditedText(text);
  };

  // // Handler for comment Text area edit
  const handleTextChange = (e) => {
    const text = e.target.value;
    setEditedText(text);
  };
  const downloadCAF = async () => {
    try {
      setdownloadCAFLoader(true);

      const user_email_id = sessionStorage.getItem("user_id");
      const quoteData = sessionStorage.getItem("quoteData");
      const currProspect = JSON.parse(
        sessionStorage.getItem("currProspect") || "{}",
      );
      const clientId = sessionStorage.getItem("clientId");

      const response = await axios.post(
        `${awsUrl2}/api/generateCaf`,
        { user_email_id, quoteData, currProspect, clientId },
        { headers: { "Content-Type": "application/json" } },
      );

      const presignedUrl = response?.data?.fileUrl;
      const fileName =
        response?.data?.fileName ||
        `CAF_${
          currProspect?.companyProfile?.companyName?.value || "Document"
        }.xlsx`;

      if (!presignedUrl) {
        throw new Error("Presigned URL not found in response.");
      }

      // Trigger download in browser using returned file name
      const link = document.createElement("a");
      link.href = presignedUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading CAF:", error);
    } finally {
      setdownloadCAFLoader(false);
    }
  };

  // Onblur handler for saving the edited comments

  const setAdministrativeDataHandler = useCallback(
    (tableName, questionId, newValue, isBackupUpdate = false) => {
      setAdministrativeData((prevState) => ({
        ...prevState,
        [tableName]: prevState[tableName].map((question) => {
          if (question.questionId === questionId) {
            if (isBackupUpdate) {
              return { ...question, backupValue: newValue };
            }
            const updatedQuestion = { ...question, response: newValue };
            if (newValue === "Included") {
              if (question.response !== "Included") {
                updatedQuestion.backupValue = question.response;
              }
            } else {
              updatedQuestion.backupValue = newValue;
            }
            return updatedQuestion;
          }
          return question;
        }),
      }));
    },
    [],
  );

  const setAdministrativeCoastDataHandler = useCallback(
    (tableName, questionId, newValue, isBackupUpdate = false) => {
      setCoastPeoChargesData((prevState) => ({
        ...prevState,
        [tableName]: prevState[tableName].map((question) => {
          if (question.questionId === questionId) {
            if (isBackupUpdate) {
              return { ...question, backupValue: newValue };
            }
            const updatedQuestion = { ...question, response: newValue };
            if (newValue === "Included") {
              if (question.response !== "Included") {
                updatedQuestion.backupValue = question.response;
              }
            } else {
              updatedQuestion.backupValue = newValue;
            }
            return updatedQuestion;
          }
          return question;
        }),
      }));
    },
    [],
  );
  const saveResponseHandler = () => {
    try {
      setSaveResponseLoader(true);
      let user_email_id = sessionStorage.getItem("user_id");
      let quoteData = sessionStorage.getItem("quoteData");

      // Update the context with the current edited text
      libertateContext.updateProposalComments({
        comments,
        editedText,
        selectedTitle,
      });

      axios
        .post(
          awsUrl2 + "/api/savePeoCharges",
          JSON.stringify({
            user_email_id,
            quoteData,
            peoCharges: administrativeData,
            coastPeoCharges: coastPeoChargesData,
            editedCompanyNameViewProposal,
            proposalComments: {
              comments,
              selectedTitle,
              editedText,
            },
            selectedPeo: changePeoCharges ? "coast" : "ies",
            updatedProposalNumber: isExistingBusiness()
              ? proposalId || proposalEdit
              : proposalEdit || proposalId,
            signaturePersonInfo,
          }),
        )
        .then((res) => {
          console.log(res);
          setSaveResponseLoader(false);
        })
        .catch((error) => {
          console.log(error);
          setSaveResponseLoader(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  function generateEndorsementNumber() {
    try {
      // Get clientId from sessionStorage
      let clientId = sessionStorage.getItem("clientId");
      let dealConfirmed = sessionStorage.getItem("dealConfirmed");

      // if (
      //   dealConfirmed === false ||
      //   dealConfirmed === null ||
      //   clientId === null
      // )
      //   return;

      // Format current month/year
      let now = new Date();
      let month = String(now.getMonth() + 1).padStart(2, "0"); // MM
      let year = String(now.getFullYear()).slice(-2); // YY

      // Retrieve last sequence info from sessionStorage
      let lastData = JSON.parse(
        sessionStorage.getItem("endorsementMeta") || "{}",
      );
      let lastSeq = lastData.sequence || 0;

      // ✅ Instead of sessionStorage, check inside currProspect
      let currProspect = JSON.parse(
        sessionStorage.getItem("currProspect") || "{}",
      );

      let isNewAddition = null;

      if (currProspect.childrenLoc) {
        for (let childKey in currProspect.childrenLoc) {
          let child = currProspect.childrenLoc[childKey];

          // Check isNewAddition directly on child
          if (child.hasOwnProperty("isNewAddition")) {
            isNewAddition = child.isNewAddition;
            break;
          }

          // If not found, check inside classCodesInfo
          if (child.classCodesInfo) {
            for (let classKey in child.classCodesInfo) {
              let classInfo = child.classCodesInfo[classKey];
              if (classInfo.hasOwnProperty("isNewAddition")) {
                isNewAddition = classInfo.isNewAddition;
                break;
              }
            }
          }

          if (isNewAddition !== null) break;
        }
      }

      let newSeq;
      if (isNewAddition === "true") {
        newSeq = lastSeq + 1;
      } else if (isNewAddition === null) {
        newSeq = 1;
      } else {
        newSeq = lastSeq || 1;
      }

      // Save updated metadata
      sessionStorage.setItem(
        "endorsementMeta",
        JSON.stringify({ month, year, sequence: newSeq }),
      );

      // Construct endorsement number
      if (isExistingBusiness() && clientId) {
        return `${clientId}${month}${year}${newSeq}`;
      } else if (miscSalesforceDatacheck) {
        return `${miscSalesforceDatacheck}${month}${year}${newSeq}`;
      } else if (proposalEdit) {
        return `${proposalEdit}`;
      }
    } catch (error) {
      console.error("Error generating endorsement number:", error);
      return "0000000000"; // fallback
    }
  }

  function convertToTimestamp(dateInput) {
    if (typeof dateInput === "string" && !isNaN(Number(dateInput))) {
      return dateInput;
    }

    // If not a number, create a Date object and get the timestamp
    const date = new Date(dateInput);
    const timestampMs = date.getTime();

    return timestampMs;
  }
  console.log(editedquoteGenratedDate, "editedquoteGenratedDate");
  const timestampMs = convertToTimestamp(editedquoteGenratedDate);

  const downloadViewProposalHandler = async (
    pepmSelection,
    companyName,
    editedCompanyNameViewProposal,
    quoteGeneratedDate,
    quoteEffectiveDate,
    proposalId,
    signaturePersonInfo,
  ) => {
    try {
      setDownloadDocumnetloader(true);
      const savedText =
        libertateContext?.proposalCommentState?.editedText || "";
      const dealConfirmed =
        JSON.parse(sessionStorage.getItem("dealConfirmed")) || false;
      const currLoc = JSON.parse(sessionStorage.getItem("currProspect")) || {};
      const childrenLoc = currLoc?.childrenLoc || {};
      const companyProfileData = currLoc?.companyProfile;

      let newAddedStates = [];

      if (dealConfirmed) {
        Object.values(childrenLoc).forEach((loc) => {
          const stateVal = loc?.state?.value?.toLowerCase();

          // if location itself is new
          const isLocNew = loc?.isNewAddition === true;

          // if any classCode inside is new
          const hasNewClassCode = Object.values(loc?.classCodesInfo || {}).some(
            (cls) => cls?.isNewAddition === true,
          );

          if ((isLocNew || hasNewClassCode) && stateVal) {
            newAddedStates.push(stateVal);
          }
        });

        // remove duplicates (e.g., multiple classCodes in same state)
        newAddedStates = [...new Set(newAddedStates)];
      }

      const existingBusinessMap = {
        dealConfirmed,
        currLoc: currLoc?.childrenLoc,
        ...(dealConfirmed && newAddedStates.length > 0 && { newAddedStates }),
      };
      let response;
      let pepmResponse;
      let annualResponse;
      const currentDate = moment().format("MM/DD/YYYY");

      if (pepmSelection === "csa") {
        if (!changePeoCharges) {
          response = await axios.post(
            awsUrl2 + "/api/generateCsaPdfWordInno",
            JSON.stringify({
              administrativeData: changePeoCharges
                ? coastPeoChargesData
                : administrativeData,
              pricingTablesummaryData:
                libertateContext?.pricingToolData?.priceIndicationData
                  ?.classCodeTableData,
              unbundledRateData:
                libertateContext?.pricingToolData?.priceIndicationData
                  ?.classCodeTableData,
              sutaTypeMap: libertateContext?.pricingToolData?.sutaTypeMap,
              companyName,
              editedCompanyNameViewProposal,
              timestampMs,
              quoteEffectiveDate,
              proposalId: isExistingBusiness()
                ? proposalId || proposalEdit
                : proposalEdit || proposalId,
              selectedCarrier:
                libertateContext?.pricingToolData?.selectedCarrier,
              comment: savedText || "",
              existingBusinessMap,
              signaturePersonInfo,
              pepmSelection,
              pdfDownload: "pdf",
              wordDownload: "word",
              companyProfileData,
            }),
          );

          const { pdfSignedUrl, wordSignedUrl } = response?.data;

          const documentName = `${companyName}_Innoworks(Proposal ${proposalId})_CSA_${currentDate}`;

          // --- Handle PDF ---
          // pdfSignedUrl points to a JSON file in S3: { streamData: base64, pricingSummaryData: base64 }
          if (pdfSignedUrl) {
            // 1. Fetch the JSON from S3
            const s3JsonResponse = await axios.get(pdfSignedUrl);
            const jsonData = s3JsonResponse?.data;

            // 2. Pick the right base64 string:
            //    - existingBusiness → pricing summary only (pricingSummaryData)
            //    - new business     → full merged PDF (streamData)
            const base64 = jsonData?.streamData;

            // 3. Decode base64 → binary → Blob
            const byteCharacters = atob(base64);
            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteArray[i] = byteCharacters.charCodeAt(i);
            }
            const pdfBlob = new Blob([byteArray], { type: "application/pdf" });

            // 4. Trigger download
            const url = URL.createObjectURL(pdfBlob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${documentName}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(() => URL.revokeObjectURL(url), 1000);

            setDownloadDocumnetloader(false);
          } else {
            console.error("No PDF signed URL found in the response.");
            setDownloadDocumnetloader(false);
          }

          // --- Handle Word ---
          // wordSignedUrl points directly to the .docx binary in S3
          if (wordSignedUrl) {
            // 1. Fetch the .docx binary directly from S3
            const wordResponse = await axios.get(wordSignedUrl, {
              responseType: "arraybuffer",
            });

            // 2. Create Blob and trigger download
            const blob = new Blob([wordResponse?.data], {
              type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${documentName}.docx`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

            setDownloadDocumnetloader(false);
          } else {
            console.error("No Word signed URL found in the response.");
            setDownloadDocumnetloader(false);
          }
        } else {
          try {
            response = await axios.post(
              awsUrl2 + "/api/generateCsaPdfWordCoast",
              JSON.stringify({
                administrativeData: changePeoCharges
                  ? coastPeoChargesData
                  : administrativeData,
                pricingTablesummaryData:
                  libertateContext?.pricingToolData?.priceIndicationData
                    ?.classCodeTableData,
                unbundledRateData:
                  libertateContext?.pricingToolData?.priceIndicationData
                    ?.classCodeTableData,
                sutaTypeMap: libertateContext?.pricingToolData?.sutaTypeMap,
                companyName,
                editedCompanyNameViewProposal,
                timestampMs,
                quoteEffectiveDate,
                proposalId: isExistingBusiness()
                  ? proposalId || proposalEdit
                  : proposalEdit || proposalId,
                selectedCarrier:
                  libertateContext?.pricingToolData?.selectedCarrier,
                comment: savedText || "",
                existingBusinessMap,
                signaturePersonInfo,
                pepmSelection,
                pdfDownload: "pdf",
                wordDownload: "word",
                companyProfileData,
              }),
            );

            // Lambda now returns flat signed URLs directly:
            // { pdfSignedUrl: "https://...", wordSignedUrl: "https://..." }
            const { pdfSignedUrl, wordSignedUrl } = response?.data;

            const documentName = `${companyName}_Coast(Proposal ${proposalId})_CSA_${currentDate}`;

            // --- Handle PDF ---
            // pdfSignedUrl points to a JSON file in S3: { streamData: base64, pricingSummaryData: base64 }
            if (pdfSignedUrl) {
              // 1. Fetch the JSON from S3
              const s3JsonResponse = await axios.get(pdfSignedUrl);
              const jsonData = s3JsonResponse?.data;

              const base64 = jsonData?.streamData;

              // 3. Decode base64 → binary → Blob
              const byteCharacters = atob(base64);
              const byteArray = new Uint8Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteArray[i] = byteCharacters.charCodeAt(i);
              }
              const pdfBlob = new Blob([byteArray], {
                type: "application/pdf",
              });

              // 4. Trigger download
              const url = URL.createObjectURL(pdfBlob);
              const a = document.createElement("a");
              a.href = url;
              a.download = `${documentName}.pdf`;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              setTimeout(() => URL.revokeObjectURL(url), 1000);

              setDownloadDocumnetloader(false);
            } else {
              console.error("No PDF signed URL found in the response.");
              setDownloadDocumnetloader(false);
            }
            // --- Handle Word ---
            // wordSignedUrl points directly to the .docx binary in S3
            if (wordSignedUrl) {
              // 1. Fetch the .docx binary directly from S3
              const wordResponse = await axios.get(wordSignedUrl, {
                responseType: "arraybuffer",
              });

              // 2. Create Blob and trigger download
              const blob = new Blob([wordResponse?.data], {
                type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              });
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = `${documentName}.docx`;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(url);

              setDownloadDocumnetloader(false);
            } else {
              console.error("No Word signed URL found in the response.");
              setDownloadDocumnetloader(false);
            }
          } catch (error) {
            console.error("Error downloading Word doc:", error);
            setDownloadDocumnetloader(false);
          }
        }
      } else if (pepmSelection === "Both") {
        //  downloading both pemp and annual pdf's in each  coast and ies api seperately
        if (!changePeoCharges) {
          [pepmResponse, annualResponse] = await Promise.all([
            axios.post(
              awsUrl2 + "/api/generateViewProposalPdf",
              JSON.stringify({
                administrativeData: changePeoCharges
                  ? coastPeoChargesData
                  : administrativeData,
                pricingTablesummaryData:
                  libertateContext?.pricingToolData?.priceIndicationData
                    ?.classCodeTableData,
                unbundledRateData:
                  libertateContext?.pricingToolData?.priceIndicationData
                    ?.classCodeTableData,
                sutaTypeMap: libertateContext?.pricingToolData?.sutaTypeMap,
                companyName,
                editedCompanyNameViewProposal,
                timestampMs,
                quoteEffectiveDate,
                proposalId: isExistingBusiness()
                  ? proposalId || proposalEdit
                  : proposalEdit || proposalId,
                selectedCarrier:
                  libertateContext?.pricingToolData?.selectedCarrier,
                comment: savedText || "",
                existingBusinessMap,
                signaturePersonInfo,
                pepmSelection: "pepm",
              }),
            ),
            axios.post(
              awsUrl2 + "/api/generateViewProposalPdf",
              JSON.stringify({
                administrativeData: changePeoCharges
                  ? coastPeoChargesData
                  : administrativeData,
                pricingTablesummaryData:
                  libertateContext?.pricingToolData?.priceIndicationData
                    ?.classCodeTableData,
                unbundledRateData:
                  libertateContext?.pricingToolData?.priceIndicationData
                    ?.classCodeTableData,
                sutaTypeMap: libertateContext?.pricingToolData?.sutaTypeMap,
                companyName,
                editedCompanyNameViewProposal,
                timestampMs,
                quoteEffectiveDate,
                proposalId: isExistingBusiness()
                  ? proposalId || proposalEdit
                  : proposalEdit || proposalId,
                selectedCarrier:
                  libertateContext?.pricingToolData?.selectedCarrier,
                comment: savedText || "",
                existingBusinessMap,
                signaturePersonInfo,
                pepmSelection: "annual",
              }),
            ),
          ]);
        } else {
          [pepmResponse, annualResponse] = await Promise.all([
            axios.post(
              awsUrl2 + "/api/generateViewProposalCoastPdf",
              JSON.stringify({
                administrativeData: changePeoCharges
                  ? coastPeoChargesData
                  : administrativeData,
                pricingTablesummaryData:
                  libertateContext?.pricingToolData?.priceIndicationData
                    ?.classCodeTableData,
                unbundledRateData:
                  libertateContext?.pricingToolData?.priceIndicationData
                    ?.classCodeTableData,
                sutaTypeMap: libertateContext?.pricingToolData?.sutaTypeMap,
                companyName,
                editedCompanyNameViewProposal,
                timestampMs,
                quoteEffectiveDate,
                proposalId: isExistingBusiness()
                  ? proposalId || proposalEdit
                  : proposalEdit || proposalId,
                selectedCarrier:
                  libertateContext?.pricingToolData?.selectedCarrier,
                comment: savedText || "",
                existingBusinessMap,
                signaturePersonInfo,
                pepmSelection: "pepm",
              }),
            ),
            axios.post(
              awsUrl2 + "/api/generateViewProposalCoastPdf",
              JSON.stringify({
                administrativeData: changePeoCharges
                  ? coastPeoChargesData
                  : administrativeData,
                pricingTablesummaryData:
                  libertateContext?.pricingToolData?.priceIndicationData
                    ?.classCodeTableData,
                unbundledRateData:
                  libertateContext?.pricingToolData?.priceIndicationData
                    ?.classCodeTableData,
                sutaTypeMap: libertateContext?.pricingToolData?.sutaTypeMap,
                companyName,
                editedCompanyNameViewProposal,
                timestampMs,
                quoteEffectiveDate,
                proposalId: isExistingBusiness()
                  ? proposalId || proposalEdit
                  : proposalEdit || proposalId,
                selectedCarrier:
                  libertateContext?.pricingToolData?.selectedCarrier,
                comment: savedText || "",
                existingBusinessMap,
                signaturePersonInfo,
                pepmSelection: "annual",
              }),
            ),
          ]);
        }
        // pepm pdf download
        if (pepmResponse?.data?.signedUrl) {
          const streamResponse = await axios.get(pepmResponse?.data?.signedUrl);

          pepmResponse.data = streamResponse?.data;

          // Decode the base64 string back into binary data
          const binaryStreamData = atob(pepmResponse?.data.streamData);
          // Convert the binary data into a Uint8Array
          const byteStreamArray = new Uint8Array(binaryStreamData.length);
          for (let i = 0; i < binaryStreamData.length; i++) {
            byteStreamArray[i] = binaryStreamData.charCodeAt(i);
          }
          const binaryPricingSummaryData = atob(
            pepmResponse?.data.pricingSummaryData,
          );
          const bytePricingSummaryArray = new Uint8Array(
            binaryPricingSummaryData.length,
          );
          for (let i = 0; i < binaryPricingSummaryData.length; i++) {
            bytePricingSummaryArray[i] = binaryPricingSummaryData.charCodeAt(i);
          }
          const streamblob = new Blob([byteStreamArray], {
            type: "application/pdf",
          });
          const pricingSummaryblob = new Blob([bytePricingSummaryArray], {
            type: "application/pdf",
          });
          let mergedPdfBlob;
          isExistingBusiness()
            ? (mergedPdfBlob = await mergePdf([pricingSummaryblob]))
            : (mergedPdfBlob = await mergePdf([
                streamblob,
                pricingSummaryblob,
              ]));
          // Create a URL for the Blob and open it
          const url = URL.createObjectURL(mergedPdfBlob);
          // Create an anchor element
          const a = document.createElement("a");
          a.href = url;

          let currProspect = JSON.parse(sessionStorage.getItem("currProspect"));
          let documentName = isExistingBusiness()
            ? `${currProspect?.companyProfile?.companyName?.value}_${
                changePeoCharges ? "Coast" : "INNO"
              }_${proposalId}_${"PEPM"}_Endorsement`
            : `__AltMkt_${
                changePeoCharges ? "Coast" : "INNO"
              }_${"PEPM"}_Proposal_${
                currProspect?.companyProfile?.companyName?.value
              } (PROPOSAL ${proposalEdit})_${moment
                .unix(quoteGeneratedDate / 1000)
                .format("MM/DD/YYYY")}_ver1`;

          a.download = `${documentName}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setDownloadDocumnetloader(false);
          // Revoke the object URL after some time to free up memory
          setTimeout(() => URL.revokeObjectURL(url), 1000);
        } else {
          console.error("No PDF data found in the response.");
        }
        // annual pdf download
        if (annualResponse?.data?.signedUrl) {
          const streamResponse = await axios.get(
            annualResponse?.data?.signedUrl,
          );

          annualResponse.data = streamResponse?.data;

          // Decode the base64 string back into binary data
          const binaryStreamData = atob(annualResponse?.data.streamData);
          // Convert the binary data into a Uint8Array
          const byteStreamArray = new Uint8Array(binaryStreamData.length);
          for (let i = 0; i < binaryStreamData.length; i++) {
            byteStreamArray[i] = binaryStreamData.charCodeAt(i);
          }
          const binaryPricingSummaryData = atob(
            annualResponse?.data.pricingSummaryData,
          );
          const bytePricingSummaryArray = new Uint8Array(
            binaryPricingSummaryData.length,
          );
          for (let i = 0; i < binaryPricingSummaryData.length; i++) {
            bytePricingSummaryArray[i] = binaryPricingSummaryData.charCodeAt(i);
          }
          const streamblob = new Blob([byteStreamArray], {
            type: "application/pdf",
          });
          const pricingSummaryblob = new Blob([bytePricingSummaryArray], {
            type: "application/pdf",
          });
          let mergedPdfBlob;
          isExistingBusiness()
            ? (mergedPdfBlob = await mergePdf([pricingSummaryblob]))
            : (mergedPdfBlob = await mergePdf([
                streamblob,
                pricingSummaryblob,
              ]));
          // Create a URL for the Blob and open it
          const url = URL.createObjectURL(mergedPdfBlob);
          // Create an anchor element
          const a = document.createElement("a");
          a.href = url;

          let currProspect = JSON.parse(sessionStorage.getItem("currProspect"));
          let documentName = isExistingBusiness()
            ? `${currProspect?.companyProfile?.companyName?.value}_${
                changePeoCharges ? "Coast" : "INNO"
              }_${proposalId}_${"Annual"}_Endorsement`
            : `__AltMkt_${
                changePeoCharges ? "Coast" : "INNO"
              }_${"Annual"}_Proposal_${
                currProspect?.companyProfile?.companyName?.value
              } (PROPOSAL ${proposalEdit})_${moment
                .unix(quoteGeneratedDate / 1000)
                .format("MM/DD/YYYY")}_ver1`;

          a.download = `${documentName}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setDownloadDocumnetloader(false);
          // Revoke the object URL after some time to free up memory
          setTimeout(() => URL.revokeObjectURL(url), 1000);
        } else {
          console.error("No PDF data found in the response.");
        }
      } else if (pepmSelection === "exhibitb") {
        if (!changePeoCharges) {
          response = await axios.post(
            awsUrl2 + "/api/generateExhibitBInno",
            JSON.stringify({
              administrativeData: changePeoCharges
                ? coastPeoChargesData
                : administrativeData,
              pricingTablesummaryData:
                libertateContext?.pricingToolData?.priceIndicationData
                  ?.classCodeTableData,
              unbundledRateData:
                libertateContext?.pricingToolData?.priceIndicationData
                  ?.classCodeTableData,
              sutaTypeMap: libertateContext?.pricingToolData?.sutaTypeMap,
              companyName,
              editedCompanyNameViewProposal,
              timestampMs,
              quoteEffectiveDate,
              proposalId: isExistingBusiness()
                ? proposalId || proposalEdit
                : proposalEdit || proposalId,
              selectedCarrier:
                libertateContext?.pricingToolData?.selectedCarrier,
              // sending the latest comment to generateViewProposalPdf api
              comment: savedText || "",
              existingBusinessMap,
              signaturePersonInfo,
              pepmSelection,
            }),
          );
          try {
            if (response?.data?.signedUrl) {
              const streamResponse = await axios.get(response?.data?.signedUrl);

              response.data = streamResponse?.data;

              const binaryPricingSummaryData = atob(
                response?.data.pricingSummaryData,
              );
              const bytePricingSummaryArray = new Uint8Array(
                binaryPricingSummaryData.length,
              );
              for (let i = 0; i < binaryPricingSummaryData.length; i++) {
                bytePricingSummaryArray[i] =
                  binaryPricingSummaryData.charCodeAt(i);
              }
              // const streamblob = new Blob([byteStreamArray], {
              //   type: "application/pdf",
              // });
              const pricingSummaryblob = new Blob([bytePricingSummaryArray], {
                type: "application/pdf",
              });
              let mergedPdfBlob = await mergePdf([pricingSummaryblob]);

              // Create a URL for the Blob and open it
              const url = URL.createObjectURL(mergedPdfBlob);
              // Create an anchor element
              const a = document.createElement("a");
              a.href = url;

              let currProspect = JSON.parse(
                sessionStorage.getItem("currProspect"),
              );
              let documentName = `__AltMkt_INNO_Exhibit_B_${currProspect?.companyProfile?.companyName?.value}`;

              a.download = `${documentName}.pdf`;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              setDownloadDocumnetloader(false);
              // Revoke the object URL after some time to free up memory
              setTimeout(() => URL.revokeObjectURL(url), 1000);
            } else {
              console.error("No PDF data found in the response.");
            }
          } catch (error) {
            console.log(error, "Error in the exhibit b creation");
          }
        } else {
          response = await axios.post(
            awsUrl2 + "/api/generateExhibitBCoast",
            JSON.stringify({
              administrativeData: changePeoCharges
                ? coastPeoChargesData
                : administrativeData,
              pricingTablesummaryData:
                libertateContext?.pricingToolData?.priceIndicationData
                  ?.classCodeTableData,
              unbundledRateData:
                libertateContext?.pricingToolData?.priceIndicationData
                  ?.classCodeTableData,
              sutaTypeMap: libertateContext?.pricingToolData?.sutaTypeMap,
              companyName,
              editedCompanyNameViewProposal,
              timestampMs,
              quoteEffectiveDate,
              proposalId: isExistingBusiness()
                ? proposalId || proposalEdit
                : proposalEdit || proposalId,
              selectedCarrier:
                libertateContext?.pricingToolData?.selectedCarrier,
              // sending the latest comment to generateViewProposalPdf api
              comment: savedText || "",
              existingBusinessMap,
              signaturePersonInfo,
              pepmSelection,
            }),
          );
          try {
            if (response?.data?.signedUrl) {
              const streamResponse = await axios.get(response?.data?.signedUrl);

              response.data = streamResponse?.data;

              const binaryPricingSummaryData = atob(
                response?.data.pricingSummaryData,
              );
              const bytePricingSummaryArray = new Uint8Array(
                binaryPricingSummaryData.length,
              );
              for (let i = 0; i < binaryPricingSummaryData.length; i++) {
                bytePricingSummaryArray[i] =
                  binaryPricingSummaryData.charCodeAt(i);
              }
              // const streamblob = new Blob([byteStreamArray], {
              //   type: "application/pdf",
              // });
              const pricingSummaryblob = new Blob([bytePricingSummaryArray], {
                type: "application/pdf",
              });
              let mergedPdfBlob = await mergePdf([pricingSummaryblob]);

              // Create a URL for the Blob and open it
              const url = URL.createObjectURL(mergedPdfBlob);
              // Create an anchor element
              const a = document.createElement("a");
              a.href = url;

              let currProspect = JSON.parse(
                sessionStorage.getItem("currProspect"),
              );
              let documentName = `__AltMkt_Coast_Exhibit_B__${currProspect?.companyProfile?.companyName?.value}`;

              a.download = `${documentName}.pdf`;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              setDownloadDocumnetloader(false);
              // Revoke the object URL after some time to free up memory
              setTimeout(() => URL.revokeObjectURL(url), 1000);
            } else {
              console.error("No PDF data found in the response.");
            }
          } catch (error) {
            console.log(error, "Error in the exhibit b creation");
          }
        }
      } else if (changePeoCharges && pepmSelection) {
        response = await axios.post(
          awsUrl2 + "/api/generateViewProposalCoastPdf",
          JSON.stringify({
            administrativeData: changePeoCharges
              ? coastPeoChargesData
              : administrativeData,
            pricingTablesummaryData:
              libertateContext?.pricingToolData?.priceIndicationData
                ?.classCodeTableData,
            unbundledRateData:
              libertateContext?.pricingToolData?.priceIndicationData
                ?.classCodeTableData,
            sutaTypeMap: libertateContext?.pricingToolData?.sutaTypeMap,
            companyName,
            editedCompanyNameViewProposal,
            timestampMs,
            quoteEffectiveDate,
            proposalId: isExistingBusiness()
              ? proposalId || proposalEdit
              : proposalEdit || proposalId,
            selectedCarrier: libertateContext?.pricingToolData?.selectedCarrier,
            // sending the latest comment to generateViewProposalPdf api
            comment: savedText || "",
            existingBusinessMap,
            signaturePersonInfo,
            pepmSelection,
          }),
        );
      } else if (!changePeoCharges && pepmSelection) {
        response = await axios.post(
          awsUrl2 + "/api/generateViewProposalPdf",
          JSON.stringify({
            administrativeData: changePeoCharges
              ? coastPeoChargesData
              : administrativeData,
            pricingTablesummaryData:
              libertateContext?.pricingToolData?.priceIndicationData
                ?.classCodeTableData,
            unbundledRateData:
              libertateContext?.pricingToolData?.priceIndicationData
                ?.classCodeTableData,
            sutaTypeMap: libertateContext?.pricingToolData?.sutaTypeMap,
            companyName,
            editedCompanyNameViewProposal,
            timestampMs,
            quoteEffectiveDate,
            proposalId: isExistingBusiness()
              ? proposalId || proposalEdit
              : proposalEdit || proposalId,
            selectedCarrier: libertateContext?.pricingToolData?.selectedCarrier,
            // sending the latest comment to generateViewProposalPdf api
            comment: savedText || "",
            existingBusinessMap,
            signaturePersonInfo,
            pepmSelection,
          }),
        );
      }

      if (response?.data?.signedUrl) {
        const streamResponse = await axios.get(response?.data?.signedUrl);

        response.data = streamResponse?.data;

        // Decode the base64 string back into binary data
        const binaryStreamData = atob(response?.data.streamData);
        // Convert the binary data into a Uint8Array
        const byteStreamArray = new Uint8Array(binaryStreamData.length);
        for (let i = 0; i < binaryStreamData.length; i++) {
          byteStreamArray[i] = binaryStreamData.charCodeAt(i);
        }
        const binaryPricingSummaryData = atob(
          response?.data.pricingSummaryData,
        );
        const bytePricingSummaryArray = new Uint8Array(
          binaryPricingSummaryData.length,
        );
        for (let i = 0; i < binaryPricingSummaryData.length; i++) {
          bytePricingSummaryArray[i] = binaryPricingSummaryData.charCodeAt(i);
        }
        const streamblob = new Blob([byteStreamArray], {
          type: "application/pdf",
        });
        const pricingSummaryblob = new Blob([bytePricingSummaryArray], {
          type: "application/pdf",
        });
        let mergedPdfBlob;
        isExistingBusiness()
          ? (mergedPdfBlob = await mergePdf([pricingSummaryblob]))
          : (mergedPdfBlob = await mergePdf([streamblob, pricingSummaryblob]));
        // Create a URL for the Blob and open it
        const url = URL.createObjectURL(mergedPdfBlob);
        // Create an anchor element
        const a = document.createElement("a");
        a.href = url;

        let currProspect = JSON.parse(sessionStorage.getItem("currProspect"));
        let documentName = isExistingBusiness()
          ? `${currProspect?.companyProfile?.companyName?.value}_${
              changePeoCharges ? "Coast" : "INNO"
            }_${proposalId}_${
              pepmSelection === "pepm" ? "PEPM" : "Annual"
            }_Endorsement`
          : `__AltMkt_${changePeoCharges ? "Coast" : "INNO"}_${
              pepmSelection === "pepm" ? "PEPM" : "Annual"
            }_Proposal_${
              currProspect?.companyProfile?.companyName?.value
            } (PROPOSAL ${proposalEdit})_${moment
              .unix(quoteGeneratedDate / 1000)
              .format("MM/DD/YYYY")}_ver1`;

        a.download = `${documentName}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setDownloadDocumnetloader(false);
        // Revoke the object URL after some time to free up memory
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      } else {
        console.error("No PDF data found in the response.");
      }
    } catch (error) {
      console.error("Error generating or merging PDF:", error);
      setDownloadDocumnetloader(false);
    }
  };

  // PDF merging function
  const mergePdf = async (files) => {
    try {
      const merger = new PDFMerger();

      for (const file of files) {
        if (!(file instanceof Blob)) {
          console.error("Invalid PDF file:", file);
          continue;
        }
        await merger.add(file);
      }

      return await merger.saveAsBlob();
    } catch (error) {
      console.error("Error merging PDF files:", error);
      return null;
    }
  };

  // Reset handler
  const handleResetComment = () => {
    // Find the default text for the currently selected title
    const defaultComment = proposalComments.find(
      (comment) => comment.Title === selectedTitle,
    );

    if (defaultComment) {
      setEditedText(defaultComment.Text);

      // Also update the context if needed
      libertateContext.updateProposalComments({
        editedText: defaultComment.Text,
        selectedTitle,
      });
    }
  };

  const isDisabled = isExistingBusiness();

  const buttonEnableCriteria = {
    sendToSunz: () => {
      return ["carrier_ae", "carrier_s"].includes(
        libertateContext?.pricingToolData?.selectedCarrier,
      );
    },
    sendToUw: () => {
      return ["carrier_k"].includes(
        libertateContext?.pricingToolData?.selectedCarrier,
      );
    },
    requestApproval: () => {
      return (
        loggedInUser?.data?.groups?.includes(
          process.env.REACT_APP_SALES_GROUP,
        ) && !isExistingBusiness()
      );
    },
    decisionSection: () => {
      return (
        loggedInUser?.data?.groups?.includes(
          process.env.REACT_APP_ADMIN_GROUP,
        ) && !isExistingBusiness()
      );
    },
  };
  let buttonDisplayCarrierName = "SUNZ";
  try {
    if (process.env.REACT_APP_MODE === "beta") {
      buttonDisplayCarrierName = "Carrier B";
    }
  } catch (error) {}

  const toastSuccess = (text) =>
    toast.success(text, {
      duration: 3000,
    });

  const toastError = (text) =>
    toast.error(text, {
      duration: 3000,
    });

  let isDisabledDropDown;
  if (isExistingBusiness()) {
    isDisabledDropDown = shouldDisableActionButton() && isExistingBusiness();
  }
  return (
    <Fragment>
      <div id="viewProposal">
        <div
          className="compName"
          style={{
            fontSize: "20px",
            fontWeight: "600",
            color: "#2c2e33",
            marginTop: "35px",
          }}
        >
          <div className="container-switch d-flex justify-content-between align-items-baseline  my-2">
            <input
              type="checkbox"
              id="checkbox"
              checked={changePeoCharges}
              onChange={(e) => coastChanges(e.target.checked)}
            />
            <label htmlFor="checkbox" className="label">
              <span className="text ies">IES</span>
              <span className="text coast">Coast</span>
            </label>
            <p
              style={{
                marginRight: "1.5rem",
              }}
            >
              {companyName}
            </p>
          </div>
        </div>
        <div className="sectionContent1">
          <div>
            {displayTable && (
              <div className="pink-header m-0 p-0 mb-3 bg-white">
                <div className="font-family-montserrat-bold headings">
                  PEO Charges
                </div>
              </div>
            )}
          </div>
          {displayTable && (
            <div>
              {administrativeData &&
                Object.keys(administrativeData).length > 0 && (
                  <Fragment>
                    <Administrative
                      disabled={isDisabled}
                      key={"administrativeServicekey"}
                      administrativeData={
                        administrativeData?.["administrativeServicekey"]
                      }
                      coastPeoChargesData={
                        coastPeoChargesData?.["administrativeServicekey"]
                      }
                      tableName={"administrativeServicekey"}
                      HeadingValue={"Administration Service Charges"}
                      changePeoCharges={changePeoCharges}
                      setAdministrativeData={setAdministrativeDataHandler}
                      setAdministrativeCoastData={
                        setAdministrativeCoastDataHandler
                      }
                      administrativeDataLoader={administrativeDataLoader}
                    />
                    <Administrative
                      disabled={isDisabled}
                      key={"optionalAdditionalServiceKey"}
                      administrativeData={
                        administrativeData?.["optionalAdditionalServiceKey"]
                      }
                      coastPeoChargesData={
                        coastPeoChargesData?.["optionalAdditionalServiceKey"]
                      }
                      tableName={"optionalAdditionalServiceKey"}
                      HeadingValue={"Optional Service Administration Charges"}
                      changePeoCharges={changePeoCharges}
                      setAdministrativeData={setAdministrativeDataHandler}
                      setAdministrativeCoastData={
                        setAdministrativeCoastDataHandler
                      }
                      administrativeDataLoader={administrativeDataLoader}
                    />
                    <Administrative
                      disabled={isDisabled}
                      key={"programDetailsAdditionalServiceKey"}
                      administrativeData={
                        administrativeData?.[
                          "programDetailsAdditionalServiceKey"
                        ]
                      }
                      coastPeoChargesData={
                        coastPeoChargesData?.[
                          "programDetailsAdditionalServiceKey"
                        ]
                      }
                      tableName={"programDetailsAdditionalServiceKey"}
                      HeadingValue={"Program Details"}
                      changePeoCharges={changePeoCharges}
                      setAdministrativeData={setAdministrativeDataHandler}
                      setAdministrativeCoastData={
                        setAdministrativeCoastDataHandler
                      }
                      administrativeDataLoader={administrativeDataLoader}
                    />
                  </Fragment>
                )}

              {administrativeDataLoader && (
                <div className="d-flex justify-content-center">
                  <SmallLoader />
                </div>
              )}
            </div>
          )}
          <div>
            {/* prcing indication preview */}
            <div id="priceIndicationPreview">
              {displayTable && (
                <div className=" mt-5">
                  <div className="pink-header m-0 p-0 mb-3 bg-white">
                    <div className="font-family-montserrat-bold headings">
                      Price Indication Preview
                    </div>
                  </div>
                </div>
              )}

              <div style={{ padding: "0px 15px" }}>
                {/*pricing summary*/}
                {displayTable && (
                  <div>
                    <PricingTableSummary
                      disabled={isDisabled}
                      styles={styles}
                      data={
                        libertateContext?.pricingToolData?.priceIndicationData
                          ?.classCodeTableData
                      }
                      selectedCarrier={
                        libertateContext?.pricingToolData?.selectedCarrier
                      }
                      sutaTypeMap={
                        libertateContext?.pricingToolData?.sutaTypeMap
                      }
                      proposalNumber={
                        isExistingBusiness() ? proposalId : proposalEdit
                      }
                      updateProposalNumber={setProposalEditNumber}
                      companyName={companyName}
                      editedCompanyNameViewProposal={
                        editedCompanyNameViewProposal
                      }
                      setEditedCompanyNameViewProposal={
                        setEditedCompanyNameViewProposal
                      }
                      editedquoteGenratedDate={editedquoteGenratedDate}
                      seteditedquoteGenratedDate={seteditedquoteGenratedDate}
                      companyNameError={companyNameError}
                      setSignaturePersonInfo={setSignaturePersonInfo}
                      signatureNamesDB={signatureNamesDB}
                      companyProfileData={companyProfileData}
                      signaturePersonInfo={signaturePersonInfo}
                    />
                  </div>
                )}
                {/* end pricing summary*/}

                {/* Dropdown and comment area added here */}

                {displayTable && (
                  <div
                    style={{
                      maxWidth: "800px",
                      margin: "0 auto",
                      padding: "20px",
                    }}
                  >
                    {/* Dropdown and Reset Button Row */}
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginBottom: "20px",
                        alignItems: "center",
                      }}
                    >
                      <select
                        disabled={isDisabled}
                        id="comment-select"
                        value={selectedTitle}
                        onChange={handleTitleChange}
                        style={{
                          flex: 1,
                          padding: "8px",
                          fontSize: "16px",
                          minWidth: "0",
                        }}
                      >
                        {comments.map((comment, index) => (
                          <option key={index} value={comment.Title}>
                            {comment.Title}
                          </option>
                        ))}
                      </select>

                      <button
                        disabled={isDisabled}
                        onClick={handleResetComment}
                        type="button"
                        style={{
                          padding: "8px 12px",
                          border: "1px solid #008dda",
                          borderRadius: "4px",
                          backgroundColor: "transparent",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transition: "all 0.2s ease",
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor =
                            "rgba(0, 141, 218, 0.1)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor = "transparent";
                        }}
                        title="Reset"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#008dda"
                          viewBox="0 0 16 16"
                        >
                          <path d="M1.161 8a6.84 6.84 0 1 0 6.842-6.84.58.58 0 1 1 0-1.16 8 8 0 1 1-6.556 3.412l-.663-.577a.58.58 0 0 1 .227-.997l2.52-.69a.58.58 0 0 1 .728.633l-.332 2.592a.58.58 0 0 1-.956.364l-.643-.56A6.8 6.8 0 0 0 1.16 8z" />
                          <path d="M6.641 11.671V8.843h1.57l1.498 2.828h1.314L9.377 8.665c.897-.3 1.427-1.106 1.427-2.1 0-1.37-.943-2.246-2.456-2.246H5.5v7.352zm0-3.75V5.277h1.57c.881 0 1.416.499 1.416 1.32 0 .84-.504 1.324-1.386 1.324z" />
                        </svg>
                      </button>
                    </div>

                    <textarea
                      disabled={isDisabled}
                      id="comment-text"
                      value={editedText}
                      onChange={handleTextChange}
                      style={{
                        width: "100%", // Same width as dropdown
                        minHeight: "200px",
                        padding: "8px",
                        fontSize: "16px",
                        marginBottom: "20px",
                        boxSizing: "border-box", // Include padding in width calculation
                      }}
                    />
                  </div>
                )}

                {/* Dropdown and comment area end*/}

                {/* unbundled Rate*/}
                <div>
                  <UnbundledRate
                    styles={styles}
                    data={
                      libertateContext?.pricingToolData?.priceIndicationData
                        ?.classCodeTableData
                    }
                    selectedCarrier={
                      libertateContext?.pricingToolData?.selectedCarrier
                    }
                    sutaTypeMap={libertateContext?.pricingToolData?.sutaTypeMap}
                  />
                </div>

                {/* unbundled Rate*/}
              </div>
            </div>

            {/* save Response button moved to page bottom and is made common to both peo charges and proposal comment section */}

            <div className={styles.alignbtn}>
              {/*  */}
              {libertateContext?.pricingToolData?.selectedCarrier &&
                isExistingBusiness() && (
                  <>
                    {buttonEnableCriteria?.sendToSunz() && (
                      <button
                        className={`btn btn-warning btn-lg btn-warning-shadow btnSubmits extraBtnClass proposal_sendbtn`}
                        disabled={
                          libertateContext?.pricingToolData?.approvalStatus !==
                            "approved" || isDisabledDropDown
                        }
                        onClick={() => {
                          salesforceData && !isExistingBusiness()
                            ? window.open(
                                link_ref_instance[process.env.REACT_APP_MODE](
                                  salesforceData.opportunityId,
                                ),
                                "_blank",
                                "noopener,noreferrer",
                              )
                            : updatePopUpData({
                                show: true,
                                title: "",
                                children: (
                                  <h4>
                                    On click of Yes the Submission will be sent
                                    to SUNZ team for underwriting
                                  </h4>
                                ),
                                acceptBtn: "Yes",
                                rejectBtn: "No",
                                acceptBtnCallback: () => {
                                  {
                                    if (
                                      libertateContext?.pricingToolData
                                        ?.approvalStatus === "approved"
                                    ) {
                                      updateApprovalStatus(
                                        "submitted",
                                        {
                                          toastSuccess,
                                          toastError,
                                        },
                                        "sunz",
                                        updatePopUpData,
                                      );
                                      libertateContext?.updatePricingToolData(
                                        "approvalStatus",
                                        "submitted",
                                      );
                                    }
                                  }
                                },
                                rejectBtnCallback: () => {},
                              });
                        }}
                      >
                        Send to {buttonDisplayCarrierName}
                      </button>
                    )}
                    {buttonEnableCriteria?.sendToUw() && (
                      <button
                        className={`btn btn-warning btn-lg btn-warning-shadow btnSubmits extraBtnClass proposal_sendbtn`}
                        disabled={
                          libertateContext?.pricingToolData?.approvalStatus ===
                          "approved"
                        }
                        onClick={() => {
                          salesforceData
                            ? window.open(
                                link_ref_instance[process.env.REACT_APP_MODE](
                                  salesforceData.opportunityId,
                                ),
                                "_blank",
                                "noopener,noreferrer",
                              )
                            : updatePopUpData({
                                show: true,
                                title: "",
                                children: (
                                  <h4>
                                    On click of Yes the Submission will be sent
                                    to Libertate team for SAIC underwriting.
                                  </h4>
                                ),
                                acceptBtn: "Yes",
                                rejectBtn: "No",
                                acceptBtnCallback: () => {
                                  if (
                                    libertateContext?.pricingToolData
                                      ?.approvalStatus === "approved"
                                  ) {
                                    updateApprovalStatus(
                                      "submitted",
                                      {
                                        toastSuccess,
                                        toastError,
                                      },
                                      "saic",
                                      updatePopUpData,
                                    );
                                    libertateContext?.updatePricingToolData(
                                      "approvalStatus",
                                      "submitted",
                                    );
                                  }
                                },
                                rejectBtnCallback: () => {},
                              });
                        }}
                      >
                        Send to UW
                      </button>
                    )}
                  </>
                )}

              {/*  */}
              {!administrativeDataLoader && !isDisabled && (
                <div className="d-flex justify-content-center align-items-center ">
                  <button
                    onClick={saveResponseHandler}
                    className="btn btn-lg btnSubmits"
                  >
                    Save Response
                  </button>
                  {saveResponseloader && (
                    <span className="saveLoader">
                      <SmallLoader />
                    </span>
                  )}
                </div>
              )}
              {!pricingTablesummaryDataLoader && !unbundledRateDataLoader && (
                <div className={styles.loaderPosition}>
                  <div>
                    <div className="btn-group btn-group-pdf">
                      <button
                        type="button"
                        className="btn btn-lg btnSubmits dropdown-toggle"
                        data-bs-toggle="dropdown"
                        data-bs-display="static"
                        aria-expanded="false"
                        disabled={
                          companyNameError || commentError || isDisabledDropDown
                        }
                      >
                        Print Doc
                      </button>

                      <ul className="dropdown-menu">
                        <li>
                          <a className="dropdown-item">
                            <div
                              onClick={() => {
                                downloadViewProposalHandler(
                                  "pepm",
                                  companyName,
                                  editedCompanyNameViewProposal,
                                  quoteGeneratedDate,
                                  quoteEffectiveDate,
                                  proposalId,
                                  signaturePersonInfo,
                                );
                              }}
                            >
                              PEPM Proposal
                            </div>
                          </a>
                        </li>

                        <li>
                          <a className="dropdown-item">
                            <div
                              onClick={() => {
                                downloadViewProposalHandler(
                                  "annual-pre",
                                  companyName,
                                  editedCompanyNameViewProposal,
                                  quoteGeneratedDate,
                                  quoteEffectiveDate,
                                  proposalId,
                                  signaturePersonInfo,
                                );
                              }}
                            >
                              Annual Proposal
                            </div>
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item">
                            <div
                              onClick={() => {
                                downloadViewProposalHandler(
                                  "Both",
                                  companyName,
                                  editedCompanyNameViewProposal,
                                  quoteGeneratedDate,
                                  quoteEffectiveDate,
                                  proposalId,
                                  signaturePersonInfo,
                                );
                              }}
                            >
                              Annual & PEPM
                            </div>
                          </a>
                        </li>
                        {!isExistingBusiness() && (
                          <li>
                            <a className="dropdown-item">
                              <div
                                onClick={() => {
                                  downloadViewProposalHandler(
                                    "exhibitb",
                                    companyName,
                                    editedCompanyNameViewProposal,
                                    quoteGeneratedDate,
                                    quoteEffectiveDate,
                                    proposalId,
                                    signaturePersonInfo,
                                  );
                                }}
                              >
                                Exhibit B
                              </div>
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>

                  {downloadDocumnetloader && (
                    <div>
                      <span className="proposalLoader">
                        <SmallLoader />
                      </span>
                    </div>
                  )}
                </div>
              )}

              {sessionStorage.getItem("dealConfirmed") && (
                <div className={styles.loaderPosition}>
                  <button
                    className="btn btn-lg btnSubmits"
                    onClick={() => downloadCAF()}
                    disabled={
                      companyNameError || commentError || isDisabledDropDown
                    }
                  >
                    Download CAF
                  </button>

                  {downloadCAFLoader && (
                    <div>
                      <span>
                        <SmallLoader />
                      </span>
                    </div>
                  )}
                </div>
              )}

              <DownloadEAcord
                selectedCarrier={
                  libertateContext?.pricingToolData?.selectedCarrier || ""
                }
                stateTableData={
                  libertateContext?.pricingToolData?.modifiersData
                    ?.stateTableData || {}
                }
                updatePopUpData={updatePopUpData}
                disabledDropDown={isDisabledDropDown}
              />
            </div>
          </div>
        </div>
      </div>
      {isExistingBusiness() ? <Toaster /> : null}
    </Fragment>
  );
};

export default FormViewProposal;
